<div>
  <${state.err ? input.catch : state.loading ? input.loading : () => {}}(state.err)/>

  <!--
  We put the streamed html in a preserved fragment.
  This allows Marko to avoid diffing that section.
  -->
  $ out.bf("@_", component, !state.err).ef();
</div>
